import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens }) => ({
  symbolItem: {
    '&:hover': {
      backgroundColor: tokens.colors.bg.greyscale.primary,
    },
  },
}));
